import { render, staticRenderFns } from "./CourseLayout.vue?vue&type=template&id=06a7c090&scoped=true"
import script from "./CourseLayout.vue?vue&type=script&lang=js"
export * from "./CourseLayout.vue?vue&type=script&lang=js"
import style0 from "./CourseLayout.vue?vue&type=style&index=0&id=06a7c090&prod&lang=css"
import style1 from "./CourseLayout.vue?vue&type=style&index=1&id=06a7c090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7c090",
  null
  
)

export default component.exports